import logger from '@utils/logger';
import { usePromoteDraftZoneMutation } from 'src/graphql/generated/graphql';

const usePromoteDraftZone = () => {
  const { mutate, mutateAsync, isError, isLoading, isSuccess, data } = usePromoteDraftZoneMutation({
    onError: (error) => {
      let loggedError: Error = Error('promoteDraftZone failed');
      if (error instanceof Error) {
        loggedError = error;
      }
      void logger.error('Call to promoteDraftZone resulted in error', loggedError);
    },
    onSuccess: (response) => {
      const { error } = response.promoteDraftZone;
      if (error) {
        void logger.error('Call to promoteDraftZone resulted in error', error);
      } else {
        void logger.info('successfully published ddraft zone');
      }
    },
  });

  const { error } = data?.promoteDraftZone ?? {};
  return {
    mutate,
    mutateAsync,
    isError,
    isLoading,
    isSuccess,
    error,
  };
};

export default usePromoteDraftZone;
